import React from 'react';
import { StyleSheet, Text, View } from '../base_components';

import { BusyComponent, BusyOverlay } from '../busy_component';
import Overlay from './overlay';
import TextButton from '../buttons/text_button';

import FuseFileStore from '../../stores/fuse_file_store';

const styles = StyleSheet.create({
  fuseFileOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  dialog: {
    padding: '3em',
    width: 'auto',
    minWidth: '20em',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  stat: {
    marginTop: '0.5em',
    marginBottom: '0.5em',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
  },
  label: {
    width: '8em',
    color: 'black',
    fontSize: '1.2em',
  },
  value: {
    color: '#333',
    fontSize: '1.2em',
  },
  button: {
    marginTop: '2em',
    height: '3em',
  },
  buttonView: {
    alignSelf: 'stretch',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

type Props = {
  file: any;
  volumeId: number;
  onClose: () => void;
  onRefresh: () => void;
};

export default class FuseFileOverlay extends BusyComponent<Props> {
  _onUndelete = () => {
    const { volumeId, file } = this.props;
    if (this.setBusy()) {
      const { file_id } = file;
      FuseFileStore.undelete({ volume_id: volumeId, file_id }, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Undelete failed');
        } else {
          file.is_deleted = 0;
          this.forceUpdate();
          this.props.onRefresh();
          window.alert('Undeleted!');
        }
      });
    }
  };
  _onUnlock = () => {
    const { volumeId, file } = this.props;
    if (this.setBusy()) {
      const { file_id } = file;
      FuseFileStore.unlock({ volume_id: volumeId, file_id }, (err) => {
        this.clearBusy();
        if (err) {
          window.alert('Unlock failed');
        } else {
          file.lock_device_name = null;
          file.lock_user_name = null;
          this.forceUpdate();
          this.props.onRefresh();
          window.alert('Unlocked!');
        }
      });
    }
  };

  render() {
    const { file, onClose } = this.props;
    const {
      file_id,
      file_path,
      file_hash,
      size,
      is_deleted,
      in_s3,
      lock_device_name,
      lock_user_name,
    } = file;
    const file_name = file_path.match(/[^/]*$/)[0];
    const path = file_path.slice(0, file_path.length - file_name.length);

    let deleted = null;
    let undelete = null;
    if (is_deleted) {
      deleted = <Stat label='Status' value='deleted' />;
      undelete = (
        <TextButton
          style={styles.button}
          text='Undelete File'
          onPress={this._onUndelete}
        />
      );
    }
    let locks = null;
    let unlock = null;
    if (lock_device_name) {
      locks = (
        <>
          <Stat label='Lock Device' value={lock_device_name} />
          <Stat label='Lock User' value={lock_user_name} />
        </>
      );
      unlock = (
        <TextButton
          style={styles.button}
          text='Unlock File'
          onPress={this._onUnlock}
        />
      );
    }

    return (
      <View style={styles.fuseFileOverlay}>
        <Overlay dialogStyle={styles.dialog} onClose={onClose}>
          <Stat label='File' value={file_name} />
          <Stat label='Path' value={path} />
          <Stat label='File ID' value={file_id} />
          <Stat label='Hash' value={file_hash} />
          <Stat label='Size' value={size} />
          <Stat
            label='Last Updated'
            value={new Date(file.last_updated).toLocaleString()}
          />
          <Stat label='In S3' value={in_s3 ? 'Yes' : 'No'} />
          {locks}
          {deleted}
          <View style={styles.buttonView}>
            {undelete}
            {unlock}
          </View>
        </Overlay>
        <BusyOverlay isBusy={this.state.is_busy} />
      </View>
    );
  }
}

function Stat(props) {
  const { label, value } = props;
  return (
    <View style={styles.stat}>
      <Text style={styles.label}>{label + ':'}</Text>
      <Text style={styles.value}>{value}</Text>
    </View>
  );
}
